// lib/ui/compose-refs.ts — plusieurs `ref` sur un même nœud (celle de
// l'appelant ET celle d'une primitive). Source unique : la copie qui vivait
// dans `components/ui/tooltip.tsx` y est désormais importée.
import type * as React from "react";

export function composeRefs<T>(...refs: Array<React.Ref<T> | undefined>): React.Ref<T> | undefined {
  const kept = refs.filter((r): r is React.Ref<T> => r != null);
  if (kept.length <= 1) return kept[0];
  // Pas de valeur de retour ⇒ React rappelle la callback avec `null` au
  // démontage, ce qui remet les deux `ref` à zéro.
  return (node: T | null) => {
    for (const ref of kept) {
      if (typeof ref === "function") ref(node);
      else (ref as React.RefObject<T | null>).current = node;
    }
  };
}
